import * as bi from 'react-bootstrap-icons';
import { IClientTripBrief } from '@bustickus/models-client';
import { bookingPageNavigate } from 'common/navigation';
import { Button, Flex } from 'components';
import { Icon } from 'shared/components';
import './style.scss';

interface IProps {
  trip: IClientTripBrief;
  backTrip?: IClientTripBrief | null;
  dCityId: string | null | undefined;
  aCityId: string | null | undefined;
}

function TicketDataBlock(props: IProps) {
  const price = Math.floor(props.trip.price + (props.backTrip?.price ?? 0));
  const priceString = new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(price);

  const handleTripClick = () => bookingPageNavigate(props.trip, props.backTrip, props.dCityId, props.aCityId);

  return (
    <Flex
      direction='column'
      className='ticket-data-Majs'
      gap={20}
    >
      <Flex direction='column'>
        {props.trip.number && (
          <Flex
            gap={5}
            alignItems='center'
          >
            <Icon color='red'>
              <bi.BusFront />
            </Icon>
            <b>Номер рейса:</b>
            <span>{props.trip.number}</span>
          </Flex>
        )}

        <Flex
          gap={5}
          alignItems='center'
        >
          <Icon color='red'>
            <bi.Coin />
          </Icon>
          <b>{priceString}</b>
          <span>за билет</span>
        </Flex>
        <Flex
          gap={5}
          alignItems='center'
        >
          <Icon color='red'>
            <bi.Ticket />
          </Icon>
          <b>{props.trip.tickets}</b>
          <span>билетов</span>
        </Flex>
        {props.trip.documents.needPassport && (
          <Flex
            gap={5}
            alignItems='center'
          >
            <Icon color='red'>
              <bi.PassportFill />
            </Icon>
            <span>Нужен паспорт</span>
          </Flex>
        )}
        {props.trip.documents.needForeignPassport && (
          <Flex
            gap={5}
            alignItems='center'
          >
            <Icon color='red'>
              <bi.PassportFill />
            </Icon>
            <span>Нужен заграничный паспорт</span>
          </Flex>
        )}
        {props.trip.documents.visas.map((x) => (
          <Flex
            key={x.id}
            gap={5}
            alignItems='center'
          >
            <Icon color='red'>
              <bi.Passport />
            </Icon>
            <span>{x.name}</span>
          </Flex>
        ))}
      </Flex>

      <Flex
        direction='column'
        gap={5}
      >
        <Button
          color={props.trip.isAvailable ? 'red' : 'transparent-red'}
          disabled={!props.trip.isAvailable}
          onClick={handleTripClick}
        >
          {props.trip.isAvailable ? 'К покупке' : 'Покупка недоступна'}
        </Button>
        <div className='trip-carrier-name-Majsh'>{props.trip.carrierName}</div>
      </Flex>
    </Flex>
  );
}

export default TicketDataBlock;
